import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { AdsGETApi, AdsGETApiAuth, AdsPOSTApi, AdsPUTApi, ExamBlockPlaceHolder, NodePOSTApiAuth, NodePOSTApiResetEmail } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import { logout } from '../../../redux/action';
import NotFound from '../../NotFound';
import Chapters from './Chapters';
import UploadAnswer from './UploadAnswer';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const slug = {
  "ubt": "UBT",
  "cbt-chemical": "CBT CHEMICAL",
  "cbt-electronics-electricity": "CBT ELECTRONIC ELECTRCITY",
  "cbt-food-related": "CBT FOOD RELATED",
  "cbt-mechinery-molding": "CBT MACHINERY,MOLDING",
  "cbt-metal": "CBT METAL",
  "cbt-pulp-paper-wood": "CBT PULP PAPER WOOD",
  "cbt-rubber": "CBT RUBBER",
  "cbt-textile-sewing": "CBT TEXTILE SEWING"
}
export default function StartCourse() {
  const [AllExamList1, setAllExamList1] = React.useState([]);
  const [AllExamListUnavailable, setAllExamListUnavailable] = React.useState([]);
  const [reload, setReload] = React.useState(true)
  const [pagesLength, setPagesLength] = React.useState("1");
  const [pages, setPages] = React.useState(1);
  const dispatch = useDispatch()
  const [usersData, setUsersData] = React.useState({ meta: { number_of_exams: "0" } });
  const LoginState = useSelector((state) => state.LoginState);
  const [ExamFetch, setExamFetch] = React.useState(false);
  const [NotFoundData, setNotFound] = React.useState(false)
  const [courseData, setCourseData] = React.useState({});
  const [chapterData, setChapterData] = React.useState({ meta: {} });
  const [Email, setEmail] = React.useState("");
  const [Name, setName] = React.useState("");
  const [userID, setUserID] = React.useState("");
  const [newDeviceDetected, setNewDeviceDetected] = React.useState(false)
  const [choose, setChoose] = React.useState(0)
  const [OTP, setOTP] = React.useState("");
  const [OTPError, setOTPError] = React.useState(false);
  const [OTPCodeStore, setOTPCodeStore] = React.useState("");

  const getDeviceFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId; // unique & stable
  };
  const location = useLocation()
  useEffect(() => {
    GetAllData()
  }, [])

  const fetchExam = () => {
    var slug = location.pathname.slice(slugs.start_course.length + 1);
    setExamFetch(false)
    setNotFound(false)
    setReload(true)

    NodePOSTApiAuth({
      userID: LoginState.userID,
      examSlug: slug
    }, "start-course-details")
      .then((response) => {
        if (response.data.error)
          setNotFound(true)
        else {
          // console.log(response.data.chapters)
          setCourseData(response.data.course[0])
          setChapterData(response.data.chapters)
          setAllExamList1(response.data.examData)
        }
      })
      .catch(e => {
        if (e.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
      .finally(() => {
        setExamFetch(true)
        setReload(false)
      })
    console.log(slug)
  }
  const getDeviceId = () => {
    let deviceId = localStorage.getItem("device_id");

    if (!deviceId) {
      deviceId = crypto.randomUUID();
      localStorage.setItem("device_id", deviceId);
    }

    return deviceId;
  };

  const GetAllData = () => {
    AdsGETApiAuth({
      status: "any",
      "filter[meta_query][1][key]": "user_id",
      "filter[meta_query][1][value][0]": LoginState.userID,
      "filter[meta_query][1][compare]": "=",
      _fields: "meta,id"
    }, "user_data")
      .then((response) => {
        if (response.data.length !== 0) {
          var deviceid = response.data[0].meta.device_id
          var deviceid2 = response.data[0].meta.device_id2
          setName(response.data[0].meta.user_name)
          setEmail(response.data[0].meta.user_email)
          setUserID(response.data[0].id)
          // getDeviceFingerprint().then(fingerprint => 
          const fingerprint = getDeviceId()
          // {
          // if (deviceid == "") {
          //   var date = new Date()
          //   var today = date.toLocaleDateString()
          //   AdsPUTApi({
          //     meta: {
          //       device_id: `${fingerprint}`
          //     }
          //   }, slugs.db_slug_user_data, response.data[0].id)
          //     .then(res => {
          //       fetchExam()
          //     })
          // }
          // else if (deviceid == fingerprint) {
          //   fetchExam()
          // }
          // else {
          //   setNewDeviceDetected(true)
          // }
          if (deviceid == "") {
            AdsPUTApi({
              meta: {
                device_id: `${fingerprint}`
              }
            }, slugs.db_slug_user_data, response.data[0].id)
              .then(res => {
                fetchExam()
              })
          }
          else if (deviceid == fingerprint) {
            fetchExam()
          }
          else {
            // setNewDeviceDetected(true)
            if (deviceid2 == "") {
              AdsPUTApi({
                meta: {
                  device_id2: `${fingerprint}`
                }
              }, slugs.db_slug_user_data, response.data[0].id)
                .then(res => {
                  fetchExam()
                })
              // fetchExam(verifiedExamList)
            }
            else if (deviceid2 == fingerprint) {
              fetchExam()
            }
            else {
              setReload(false)
              setNewDeviceDetected(true)
            }
          }
          // })
        }
        else
          dispatch(logout())
      })
      .catch(e => {
        if (e.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
  }


  const maskEmail = (email) => {
    if (!email || !email.includes("@")) return "";

    const [username, domain] = email.split("@");

    if (username.length <= 4) {
      return `${username.charAt(0)}****@${domain}`;
    }

    return `${username.slice(0, 2)}********${username.slice(-2)}@${domain}`;
  };


  return (
    <div style={{ margin: "3px", backgroundColor: "#fff", minHeight: "95vh" }}>
      {ExamFetch &&
        <>
          {NotFoundData ?
            <NotFound /> :
            <>
              {/* <div className="row">
                <div className="col-1"></div>
                <div className="col-10 form-view mt-3">

                  <div className="row" style={{ margin: "10px" }}>
                    <h2>Course Information</h2>
                    <div>Course Name: {courseData.title.rendered}</div>
                    {courseData.meta.zoom_link !== "" &&
                      <div style={{ width: "100%", display: 'flex', marginTop: "10px" }}>
                        <a className="Link" style={{ padding: "2px 10px", borderRadius: "10px", }}
                          href={courseData.meta.zoom_link}
                        >
                          <div style={{}}>
                            Join Live Class:
                            <div style={{}}>
                              <img style={{ border: "1px solid black", borderRadius: "10px", width: "100px", objectFit: "contain" }}
                                src='https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/Screenshot-2025-09-05-at-10.00.32.png'
                              />
                            </div>
                          </div>
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div> */}
              <div className="classes-page-2">
                <section className="course-info-card">
                  <h1 className="course-info-title">Course Information</h1>

                  <p className="course-info-name">
                    <span>Course Name:</span>
                    {courseData.title.rendered || "Course"}
                  </p>
                  <a className="Link" style={{ padding: "2px 10px", borderRadius: "10px", }}
                    href={courseData.meta.zoom_link}
                  >
                    <div style={{}}>
                      Join Live Class:
                      <span style={{}}>
                        <img style={{ border: "1px solid black", borderRadius: "10px", width: "100px", objectFit: "contain" }}
                          src='https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/Screenshot-2025-09-05-at-10.00.32.png'
                        />
                      </span>
                    </div>
                  </a>
                </section>
              </div>
              <Chapters
                ChapterData={chapterData}
                reload={reload}
                setReload={setReload}
              />

              {AllExamList1.length !== 0 &&
                <div style={{ marginVertical: 10 }}>
                  <div className="row">
                    <div className="col-1"></div>
                    <div className="col-10 form-view mt-3">
                      <div className="row" style={{ margin: "10px", }}>
                        <span>MCQs</span>
                        <div className='row'>
                          {AllExamList1.map((item, index) => (
                            <div key={index} className='col-md-3' >
                              <>

                                <ExamBlock item={item}
                                  examSlug={slugs.start_exam}
                                />
                              </>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </>
          }
        </>
      }
      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {newDeviceDetected &&
        <div className="modal"
          onClick={() => {
          }}
        >
          <div>
            <div className="row " style={{ minHeight: "10vh", marginTop: "10vh" }}>
              <div className="col-sm-3 col-1"></div>
              <div className="col-sm-6 col-10 pb-5  bg-white  shadow">
                {choose == 0 &&
                  <>
                    <div className="device-popup-overlay">
                      <div className="device-popup">
                        <div className="warning-icon">!</div>

                        <h2 className="device-popup-title">Warning</h2>

                        <p className="device-popup-message">
                          तपाईंको Account अर्को Device मा Login भएको छ।
                          <br />
                          एक समयमा एउटा Device मा मात्र Login गर्न सकिन्छ।
                          <br />
                          कृपया Logout गर्नुहोस् वा यो Device प्रयोग गर्न{" "}
                          <strong>Reset Device</strong> गर्नुहोस्।
                          <br />
                          Reset Device गर्दा OTP तपाईंको registered Email
                          <br />

                          <span className="masked-email">
                            {maskEmail(Email)}
                          </span>

                          <br />
                          मा पठाइनेछ।
                        </p>

                        <div className="device-popup-note">
                          OTP verify भएपछि पुरानो Device automatically Logout हुनेछ।
                        </div>

                        <div className="device-popup-actions">
                          <button className="device-popup-btn logout-btn"
                            onClick={() => {
                              dispatch(logout())
                            }}
                          >
                            Logout
                          </button>

                          <button className="device-popup-btn reset-btn"
                            onClick={() => {
                              function generateRandomNumber() {
                                var minm = 100000;
                                var maxm = 999999;
                                return Math.floor(Math.random() * (maxm - minm + 1)) + minm;
                              }
                              const OTPCode = generateRandomNumber()
                              setOTPCodeStore(OTPCode)
                              NodePOSTApiResetEmail({
                                email: `${Email}`,
                                subject: `Reset Device ${OTPCode} Loksewa Network`,
                                body: `
      नमस्कार ${Name},
      <br/>
      <br/>
      तपाईंको खातासँग जोडिएको Device Reset गर्न अनुरोध प्राप्त भएको छ।
      <br/>
      Device Reset प्रक्रिया पूरा गर्न तल दिइएको OTP कोड प्रयोग गर्नुहोस्:
      <br/>
      <br/>
      OTP कोड: <strong>${OTPCode}</strong>
      <br/>
      <br/>
      यदि तपाईंले Device गर्न अनुरोध गर्नुभएको होइन भने, यो कोड कसैसँग साझा नगर्नुहोस् र यो इमेललाई बेवास्ता गर्नुहोस्।
      <br/>
      <br/>
      
      सुरक्षाका लागि फोन, इमेल वा अन्य माध्यमबाट तपाईंको OTP कोड माग्ने छैन।
      <br/>
      <br/>
      
      धन्यवाद,
      <br/>
      Loksewa Network- NEA
      <br/>
      Bagbazar, Kathmandu
      `
                              }, "send_email")
                                .then(res => {
                                })
                              setChoose(1)

                            }}
                          >
                            Send OTP to Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                }
                {choose == 1 &&
                  <>
                    {/* <div className="p-5">
                            <div>Please enter the 6 digits otp received in your registered email?</div>
                            <div>
                              <input className='input-common'
                                placeholder='OTP'
                                onChange={(event) => {
                                  setOTP(event.target.value)
                                }}
                              />
                            </div>
                            <div style={{ display: 'flex', cursor: 'pointer' }} className="center">
                              <div className="sign-in-button-2 col-4">
                                Logout
                              </div>
                              <div className="sign-in-button-1 col-4 mx-1">
                                Reset Device
                              </div>
                            </div>
                          </div> */}
                    <div className="otp-overlay">
                      <div className="otp-modal">

                        <h2 className="otp-title">
                          Please enter the 6 digits OTP received in your
                          registered email?
                        </h2>

                        <input
                          type="text"
                          className="otp-input"
                          placeholder="OTP"
                          maxLength={6}
                          value={OTP}
                          onChange={(event) => {
                            setOTP(event.target.value)
                            setOTPError(false)
                          }}

                        />
                        {/* {OTPCodeStore} */}
                        <p className="otp-error">
                          {OTPError &&
                            "Incorrect OTP. Please try again."
                          }
                        </p>

                        <div className="otp-buttons">
                          <button className="logout-btn"
                            onClick={() => {
                              dispatch(logout())
                            }}
                          >
                            Logout
                          </button>

                          <button className="reset-btn"
                            onClick={() => {
                              if (OTP != OTPCodeStore)
                                setOTPError(true)
                              else {
                                setReload(true)
                                setNewDeviceDetected(false)
                                AdsPUTApi({
                                  meta: {
                                    device_id: ``
                                  }
                                }, slugs.db_slug_user_data, userID)
                                  .then(res => {
                                    GetAllData()
                                  })
                              }
                            }}
                          >
                            Reset Device
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}



const ExamBlock = ({ item, examSlug }) => {
  const location = useLocation();
  return (
    <div style={{
      margin: "5px 0px",
      border: "1.5px solid #bbb",
      borderRadius: "5px",
    }}>
      {/* {item.meta.featured_image !== "" ?
        <img className="col-12" src={item.meta.featured_image}
          style={{ objectFit: 'contain', height: "100px", borderRadius: "3px" }} />
        :
        <img className="col-12"
          src={ExamBlockPlaceHolder}
          style={{ objectFit: 'contain', height: "100px", borderRadius: "3px" }} />
      } */}
      <br />
      <Link className="col-8 Link"
        to={`${examSlug}/${item.slug}`}
      >
        <div style={{ fontWeight: "bold", textAlign: "center", fontSize: "18px" }}>
          {item.title.rendered}&nbsp;
        </div>
      </Link>

    </div >
  )

}